module.exports = __webpack_public_path__ + "img/icon1.512a16f7.png";